import React from 'react';

import TabsContainer from './TabsContainer';

interface TabsProps {
  tabColor?: string;
  textColor?: string;
  className?: string;
  containerClassName?: string;
  style?: React.CSSProperties;
  defaultActiveTabIndex?: number;
  onClick?: (tabIndex: number, tabLabel: string, tabCode?: string) => void;
  children?: React.ReactNode;
}

interface TabsState {
  activeTabIndex: number;
}

export class Tabs extends React.Component<TabsProps, TabsState> {
  constructor(props: TabsProps) {
    super(props);

    this.state = {
      activeTabIndex: props.defaultActiveTabIndex || 0,
    };
  }

  componentDidUpdate(prevProps: TabsProps) {
    if (prevProps.defaultActiveTabIndex !== this.props.defaultActiveTabIndex) {
      this.setState({ activeTabIndex: this.props.defaultActiveTabIndex as number });
    }
  }

  // Toggle currently active tab
  handleTabClick = (tabIndex: number, tabLabel: string, tabCode?: string) => {
    this.setState({
      activeTabIndex: tabIndex,
    });

    if (this.props.onClick) {
      this.props.onClick(tabIndex, tabLabel, tabCode);
    }
  };

  // Encapsulate <Tabs/> component API as props for <Tab/> children
  renderChildrenWithTabsApiAsProps() {
    return React.Children.toArray(this.props.children)
      .filter(element => element !== null)
      .map((child, index) => {
        if (!child) return null;

        return React.cloneElement(child as $FIXME, {
          onClick: this.handleTabClick,
          tabIndex: index,
          isActive: index === this.state.activeTabIndex,
          tabColor: this.props.tabColor,
        });
      });
  }

  // Render current active tab content
  renderActiveTabContent() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;

    const childrens = React.Children.toArray(children);

    if (childrens?.[activeTabIndex]) {
      return (childrens[activeTabIndex] as $FIXME).props.children;
    }
  }

  render() {
    const { style, tabColor, textColor, className, containerClassName } = this.props;

    return (
      <div className={containerClassName}>
        <TabsContainer
          style={style}
          tabColor={tabColor}
          textColor={textColor}
          className={className}
        >
          {this.renderChildrenWithTabsApiAsProps()}
        </TabsContainer>
        {this.renderActiveTabContent()}
      </div>
    );
  }
}
